import { render, staticRenderFns } from "./RepeatOnTheSelect.vue?vue&type=template&id=3864fce3"
import script from "./RepeatOnTheSelect.vue?vue&type=script&lang=js"
export * from "./RepeatOnTheSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports